const STORAGE_KEY = "office-dashboard:demoPrivacyBlur:v1";
const LEGACY_PER_TABLE_PREFIX = "office-dashboard:demoPrivacyBlur:";
const CHANGE_EVENT = "demoPrivacyBlurChange";

function safeRemove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // no-op
  }
}

function readRaw(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

function migrateLegacyPerTableKeys(): boolean {
  let anyEnabled = false;
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (
        key &&
        key.startsWith(LEGACY_PER_TABLE_PREFIX) &&
        key !== STORAGE_KEY
      ) {
        if (window.localStorage.getItem(key) === "1") anyEnabled = true;
        toRemove.push(key);
      }
    }
    for (const key of toRemove) safeRemove(key);
  } catch {
    // no-op
  }
  return anyEnabled;
}

export function loadDemoPrivacyBlur(): boolean {
  if (typeof window === "undefined") return false;
  const current = readRaw();
  const migratedEnabled = migrateLegacyPerTableKeys();
  if (!current && migratedEnabled) {
    saveDemoPrivacyBlur(true);
    return true;
  }
  return current;
}

export function saveDemoPrivacyBlur(enabled: boolean): void {
  if (typeof window === "undefined") return;
  try {
    if (enabled) {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // no-op
  }
  try {
    window.dispatchEvent(
      new CustomEvent<boolean>(CHANGE_EVENT, { detail: enabled }),
    );
  } catch {
    // no-op
  }
}

export function subscribeToDemoPrivacyBlur(
  cb: (enabled: boolean) => void,
): () => void {
  if (typeof window === "undefined") return () => {};
  const onCustom = (e: Event) => {
    const detail = (e as CustomEvent<boolean>).detail;
    cb(typeof detail === "boolean" ? detail : readRaw());
  };
  const onStorage = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) cb(readRaw());
  };
  window.addEventListener(CHANGE_EVENT, onCustom);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(CHANGE_EVENT, onCustom);
    window.removeEventListener("storage", onStorage);
  };
}

export const __testing__ = {
  STORAGE_KEY,
  LEGACY_PER_TABLE_PREFIX,
  CHANGE_EVENT,
};
